import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Auth } from 'src/app/models/auth';
import { FilterCreditHistory, FilterUseProducts } from 'src/app/models/relatorio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import { environment } from 'src/environments/environment';
import {saveAs} from 'file-saver';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-recargas-relatorio',
  templateUrl: './recargas-relatorio.component.html',
  styleUrls: ['./recargas-relatorio.component.css']
})
export class RecargasRelatorioComponent implements OnInit {
 
  constructor(
    private relatorioService: RelatorioService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    public datepipe: DatePipe,
    private modalService: NgbModal,
    private router: Router
  ) { }
  
  public currentUser: Auth;
  public filtro = new FilterCreditHistory(null,null,null,null,null,null);
  
  public startDateCtrl: FormControl = new FormControl();
  public endDateCtrl: FormControl = new FormControl();

  public dataInicio = new Date();
  public dataFim = new Date();
  public dataMaxima = new Date();
  queryDate: Date;
  
  
  public compras: any;
  public filtroOn: boolean = false;

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.dataInicio.setDate(this.dataInicio.getDate()-90);
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;

    this.carregarRelatorio(1);
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getPurchases(this.currentUser.token.assignorGuid,(page-1),+this.showItem,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.compras = response.result.purchases;
        this.totalItems = response.result.total;
        this.queryDate = new Date();
      }
    });
  }  

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  setPeriod(inicio,date: Date){
    if(inicio){
      this.filtro.dateStart = date;
      this.dataMaxima = new Date(date.getFullYear(), date.getMonth(), date.getDate()+90);
      if (this.filtro.dateEnd >= this.dataMaxima){
        this.filtro.dateEnd = this.dataMaxima;
      } else if (this.filtro.dateEnd < this.filtro.dateStart){
        this.filtro.dateEnd =  this.filtro.dateStart;
      }
    } else {
      this.filtro.dateEnd = date;
    }
  }
  
  applyFilter() {
    if(
      this.filtro.dateStart == this.dataInicio &&
      this.filtro.dateEnd == this.dataFim
    ){
      this.filtroOn = false;
      this.carregarRelatorio(1);
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
    }
  }

  deleteFilter(){
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;

    this.filtroOn = false;

    this.carregarRelatorio(1);
  }

  exportExtractExcel(){
    var result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const excelService = new ExcelService();
    const worksheets = new Array<WorksheetData>();
    const ws = new WorksheetData();
    ws.worksheetTitle = 'relatorio_recargas_' + date[2] + '-' + date[1] + '-' + date[0];
    ws.worksheetHeaders = ['Código da compra','Valor','Data de solicitação','Data de liberação','Situação'];
    ws.WorksheetRows = [];
    // /*
    this.relatorioService.getPurchases(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.purchases;

        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(r.purchaseId);
          lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
          lr.push(this.datepipe.transform(r.date, 'dd/MM/yyyy HH:mm'));
          lr.push(this.datepipe.transform(r.releaseDate, 'dd/MM/yyyy HH:mm'));
          lr.push(r.status );
          ws.WorksheetRows.push(lr);
        });

        worksheets.push(ws);

        let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');

        excelService.generateExcelReport('Relatório de recargas', worksheets, filter).xlsx
        .writeBuffer().then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, ws.worksheetTitle + '.xlsx');
        });

      }
    },
    error => {
      this.alertService.error('Ocorreu um erro ao paginar relatorio');
    });
    // */
  }

  exportExtractPdf(){
    let result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const pdfData = new PdfData();
    pdfData.PdfTitle = 'relatorio_recargas_' + date[2] + '-' + date[1] + '-' + date[0];
    pdfData.PdfHeaders = ['Código da compra','Valor','','Data de solicitação','Data de liberação','Situação'];
    pdfData.PdfRows = [];

    this.relatorioService.getPurchases(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.purchases;

        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(r.purchaseId);
          lr.push('R$');
          lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
          lr.push(this.datepipe.transform(r.date, 'dd/MM/yyyy HH:mm'));
          lr.push(this.datepipe.transform(r.releaseDate, 'dd/MM/yyyy HH:mm'));
          lr.push(r.status );
            pdfData.PdfRows.push(lr);
        });

        let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');

        const pdfService = new PdfService();
        pdfService.generatePdfReport('Relatório de recargas',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss')).getBlob((blob) => {
          saveAs(blob, pdfData.PdfTitle + '.pdf');
        });

      } else {
        this.alertService.error(response.message);
      }
    },
    error => {
      this.alertService.error(
        'Ocorreu um erro ao paginar o relatorio'
      );
    });
  }

  formatarCpf(cpf){
    if(cpf == null)
      return null
      
    const tam = environment.TOTAL_CARACTERE_CPF - cpf.toString().length;

    for (let i = 0; i < tam; i++) { cpf = '0' + cpf; }

    return cpf.slice(0,3)+"."+cpf.slice(3,6)+"."+cpf.slice(6,9)+"-"+cpf.slice(9);
  }

  toPurchaseDetails(item){
    this.router.navigate([`portal/minhasrecargas/details/${item}`]);
  }

}
